import {validate, Contains, IsInt, MinLength, Length, IsEmail, IsFQDN, IsDate, Min, Max} from 'class-validator';

export class ResetPassword {
    @Length(9)
    Login: string;

    @MinLength(1)
    Poblacion: string;

    gRecaptchaResponse: string;
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/resetPassword.entity.ts